import { render, staticRenderFns } from "./mainFacebook.vue?vue&type=template&id=7a18cc22&"
import script from "./mainFacebook.vue?vue&type=script&lang=js&"
export * from "./mainFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports